import styled from 'styled-components';
import { palette } from '@dev/ee-components';

export type StyledProps = {
    noMargin?: boolean;
};

export const Divider = styled.div<StyledProps>`
    height: 1px;
    width: 100%;
    background-color: ${palette.gray[3]};
    margin-top: ${({ noMargin }): number => (noMargin ? 0 : 32)}px;
`;

export const TipWrapper = styled.div`
    margin-top: 30px;
    width: 60px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

export const Wrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
`;

export const BasicInputWrapper = styled.div`
    margin-right: 16px;
    flex-grow: 1;
`;
export const EmailDropdownWrapper = styled.div`
    flex-grow: 1;
`;
